import React, { useState, useEffect } from 'react';
import styles from './index.module.css';
import { connect } from 'react-redux';
import { getBill } from '../actions';
import { useParams } from 'react-router-dom';

// Mock bill data - replace with decoded data from encryptedPurchaseData
const getMockBillData = () => ({
    company: {
        name: 'ABCD Stores (Pvt) Ltd',
        address: 'Pitawala, Madawala Road, Manikhinaa',
        contact: '0782345671',
        logo: 'A',
    },
    billInfo: {
        billNo: '0907823455',
        cashier: 'admin_test',
        customer: 'Anne Sheril',
        customerPhone: '0804567891',
        paymentMethod: 'card',
        billingDate: 'Feb 23, 2026 at 11:23 AM',
    },
    items: [
        { item: 'Test Product Test Product Test Product', qty: 1, price: 100.0, discount: 0, amount: 100.0 },
        { item: 'Test Product', qty: 2, price: 100.0, discount: 0, amount: 200.0 },
        { item: 'Test Product', qty: 2, price: 100.0, discount: 0, amount: 200.0 },
        { item: 'Test Product', qty: 2, price: 100.0, discount: 0, amount: 200.0 },
    ],
    summary: {
        totalAmount: 700.0,
        itemsCount: 4,
        totalDiscount: 0.0,
        payableAmount: 700.0,
        paidAmount: 1000.0,
        balance: 300.0,
    },
    footer: {
        thankYou: 'Thank you & Come Again',
        policy: 'Refund policy and related description',
    },
});

const BillView = ({ getBill }) => {
    const { encryptedPurchaseData } = useParams();
    const [billData, setBillData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        getBillData();
    }, [encryptedPurchaseData]);

    const getBillData = async () => {
        const billData = await getBill(encryptedPurchaseData);
        if (billData) {
            setBillData(billData);
        } else {
            setError('Bill not found');
        }
    };

    if (!billData && !error) {
        return (
            <div className={styles.container}>
                <div className={styles.receipt}>
                    <div className={styles.loaderContainer}>
                        <div className={styles.loader} />
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.receipt}>
                    <div className={styles.errorContainer}>{error}</div>
                </div>
            </div>
        );
    }

    const { company = {}, billInfo = {}, items = [], summary = {}, footer = {} } = billData;

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.container}>
                <div className={styles.receipt}>
                    {/* Header */}
                    <div className={styles.header}>
                        {company.logo && <div className={styles.logo}>{company.logo}</div>}
                        {company.name && <h1 className={styles.companyName}>{company.name}</h1>}
                        {company.address && <p className={styles.address}>{company.address}</p>}
                        {company.contact && <p className={styles.contact}>{company.contact}</p>}
                    </div>

                    {/* Bill Information */}
                    <div className={styles.billInfoSection}>
                        <h2 className={styles.billInfoTitle}>Bill Information</h2>
                        <div className={styles.billInfoList}>
                            <div className={styles.billInfoRow}>
                                <span className={styles.billInfoLabel}>Bill No :</span>
                                <span className={styles.billInfoValue}>{billInfo.billNo}</span>
                            </div>
                            <div className={styles.billInfoRow}>
                                <span className={styles.billInfoLabel}>Cashier :</span>
                                <span className={styles.billInfoValue}>{billInfo.cashier}</span>
                            </div>
                            <div className={styles.billInfoRow}>
                                <span className={styles.billInfoLabel}>Customer :</span>
                                <span className={styles.billInfoValue}>{billInfo.customer}</span>
                            </div>
                            <div className={styles.billInfoRow}>
                                <span className={styles.billInfoLabel}>Customer Phone :</span>
                                <span className={styles.billInfoValue}>{billInfo.customerPhone}</span>
                            </div>
                            <div className={styles.billInfoRow}>
                                <span className={styles.billInfoLabel}>Payment Method :</span>
                                <span className={styles.billInfoValue}>{billInfo.paymentMethod}</span>
                            </div>
                            <div className={styles.billInfoRow}>
                                <span className={styles.billInfoLabel}>Billing Date :</span>
                                <span className={styles.billInfoValue}>{billInfo.billingDate}</span>
                            </div>
                        </div>
                    </div>

                    {/* Items Table */}
                    <div className={styles.tableWrapper}>
                        <table className={styles.itemsTable}>
                            <thead>
                                <tr>
                                    <th className={styles.colNum}>#</th>
                                    <th className={styles.colItem}>Item</th>
                                    <th className={styles.colQty}>QTY</th>
                                    <th className={styles.colPrice}>Price</th>
                                    <th className={styles.colDiscount}>Discount</th>
                                    <th className={styles.colAmount}>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((row, index) => (
                                    <React.Fragment key={index}>
                                        <tr className={styles.itemNameRow}>
                                            <td className={styles.colNum}>{index + 1}</td>
                                            <td className={styles.colItem} colSpan={5}>
                                                {row.item}
                                                {(row.modifiers || []).map((mod, modIndex) => {
                                                    const count = Number(mod.countPerUnit != null ? mod.countPerUnit : 1);
                                                    const label = count > 1
                                                        ? `${mod.optionName} ×${count}`
                                                        : mod.optionName;
                                                    const extra = mod.amount != null
                                                        ? Number(mod.amount)
                                                        : Number(mod.price || 0) * count;
                                                    return (
                                                        <div key={`${label}-${modIndex}`} className={styles.modifierLine}>
                                                            - {label}
                                                            {Number.isFinite(extra) ? ` ${extra.toFixed(2)}` : ''}
                                                        </div>
                                                    );
                                                })}
                                            </td>
                                        </tr>
                                        <tr className={styles.itemValueRow}>
                                            <td className={styles.itemSpacer} colSpan={2} />
                                            <td className={styles.colQty}>{row.qty}</td>
                                            <td className={styles.colPrice}>
                                                {parseFloat(row.price).toFixed(2)}
                                            </td>
                                            <td className={styles.colDiscount}>
                                                {parseFloat(row.discount).toFixed(2)}
                                            </td>
                                            <td className={styles.colAmount}>
                                                {parseFloat(row.amount).toFixed(2)}
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Summary */}
                    <div className={styles.summarySection}>
                        <div className={styles.summaryRow}>
                            <span className={styles.summaryLabel}>Total Amount</span>
                            <span className={styles.summaryValue}>
                                {summary.totalAmount.toFixed(2)}
                            </span>
                        </div>
                        <div className={styles.summaryDivider} />
                        <div className={styles.summaryRow}>
                            <span className={styles.summaryLabel}>Items</span>
                            <span className={styles.summaryValue}>{summary.itemsCount}</span>
                        </div>
                        <div className={styles.summaryDivider} />
                        <div className={styles.summaryRow}>
                            <span className={styles.summaryLabel}>Total Discount</span>
                            <span className={styles.summaryValue}>
                                {summary.totalDiscount.toFixed(2)}
                            </span>
                        </div>
                        <div className={styles.summaryRow}>
                            <span className={styles.summaryLabel}>Payable Amount</span>
                            <span className={`${styles.summaryValue} ${styles.bold}`}>
                                {summary.payableAmount.toFixed(2)}
                            </span>
                        </div>
                        <div className={styles.summaryDivider} />
                        <div className={styles.summaryRow}>
                            <span className={styles.summaryLabel}>Paid Amount</span>
                            <span className={styles.summaryValue}>
                                {summary.paidAmount.toFixed(2)}
                            </span>
                        </div>
                        <div className={styles.summaryDivider} />
                        <div className={styles.summaryRow}>
                            <span className={styles.summaryLabel}>Balance</span>
                            <span className={styles.summaryValue}>
                                {summary.balance.toFixed(2)}
                            </span>
                        </div>
                        <div className={styles.summaryDivider} />
                    </div>

                    {/* Footer */}
                    <div className={styles.footer}>
                        <p className={styles.thankYou}>{footer.thankYou}</p>
                        <p className={styles.policy}>
                            {(footer.policy || '')
                                .replace(/\\n|\/n/g, '\n')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default connect(null, { getBill })(BillView);
